// Persistent referral code — set from any ?ref=XXX in URL, lives in localStorage
const KEY = "afterlist_ref";

export function captureRefFromUrl() {
  if (typeof window === "undefined") return;
  const p = new URLSearchParams(window.location.search);
  const r = p.get("ref");
  if (r && r.length <= 20) {
    localStorage.setItem(KEY, r.toUpperCase());
  }
}

export function getStoredRef() {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(KEY) || "";
}

export function clearStoredRef() {
  localStorage.removeItem(KEY);
}
